import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'app-paginator-select',
  templateUrl: './paginatorselect.component.html',
  styleUrls: ['./paginatorselect.component.scss'],
})
export class PaginatorSelectComponent implements OnInit {
  isSizeMobile = false;
  buttonPages!: (number | string)[];
  @Input() currentPage!: number;
  @Input() totalPages!: number;
  @Output() pageChange = new EventEmitter<number>();

  constructor(private breakpointObserver: BreakpointObserver) {}

  ngOnInit(): void {
    window.scrollTo(0, 0);
    const oritentation = this.breakpointObserver.observe([
      '(max-width: 768px)',
    ]);
    oritentation.subscribe((lay) => {
      this.isSizeMobile = lay.breakpoints['(max-width: 768px)'];
    });
    this.getNumberPagesPaginatorSelect(this.currentPage, this.totalPages);
  }

  getNumberPagesPaginatorSelect(start: number, end: number) {
    let totalPages = end - start + 1;
    if (start === end) {
      totalPages = end;
      if (totalPages <= 3) {
        start = 1;
        this.buttonPages = Array.from(
          { length: totalPages },
          (_, index) => start + index,
        );
      } else {
        start = start - 2;
        this.buttonPages = Array.from(
          { length: 3 },
          (_, index) => start + index,
        );
      }
    }

    if (totalPages > 1 && totalPages <= 4 && start !== end) {
      // Menos o igual 4 páginas, mostrar todas las páginas
      this.buttonPages = Array.from(
        { length: totalPages },
        (_, index) => start + index,
      );
    } else if (totalPages > 4 && start !== end) {
      // Más de 4 páginas, mostrar las primeras 3

      const firstThreePages = Array.from(
        { length: 3 },
        (_, index) => start + index,
      );

      this.buttonPages = [...firstThreePages];
    }
  }

  goToPagePaginatorSelect(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.pageChange.emit(page);
    }
  }

  nextPagePaginatorSelect() {
    this.goToPagePaginatorSelect(this.currentPage + 1);
    if (this.currentPage <= this.totalPages - 1) {
      this.getNumberPagesPaginatorSelect(this.currentPage + 1, this.totalPages);
    }
  }

  prevPagePaginatorSelect() {
    this.goToPagePaginatorSelect(this.currentPage - 1);
    if (
      this.currentPage - 1 <= this.totalPages - 3 &&
      this.currentPage - 1 !== 0
    ) {
      this.getNumberPagesPaginatorSelect(this.currentPage - 1, this.totalPages);
    }
  }

  firstPagePaginatorSelect() {
    this.goToPagePaginatorSelect(1);
    this.getNumberPagesPaginatorSelect(1, this.totalPages);
  }

  lastPagePaginatorSelect() {
    this.goToPagePaginatorSelect(this.totalPages);
    if (this.totalPages > 4) {
      this.getNumberPagesPaginatorSelect(this.totalPages - 3, this.totalPages);
    }
  }

  onPageChangePaginatorSelect(page: string | number) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.currentPage = Number(page);
    this.pageChange.emit(Number(page));
  }
}
